export default "__VITE_ASSET__D0e0P7vV__"